import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=439842d7&scoped=true"
import script from "./ServerError.vue?vue&type=script&lang=ts"
export * from "./ServerError.vue?vue&type=script&lang=ts"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=439842d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439842d7",
  null
  
)

export default component.exports